import { JsonApiPayload, ModelLike } from 'services/interfaces/JsonApiPayload';

export class PaymentMethodPayload extends JsonApiPayload {
  id: string
  guestId: string
  pmsId: string
  type: string
  cardholderName: string
  cardNumber: string
  cardVerification: string
  cardType: string
  last4: string
  expiry: string
  address: string
  address2: string
  address3: string
  address4: string
  city: string
  state: string
  postalCode: string
  country: string
  primary: boolean
  active: boolean
  createdAt?: string
  updatedAt?: string

  static new(model?: ModelLike) {
    return super.fill(new this(), model);
  }

  static getSchema() {
    const result = super._getSchema(this, []);
    return result;
  }
}
